
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import getStylesFromCssString from './getStylesFromCssString';
import getStylesFromDefinition from './getStylesFromDefinition';
import processTemplateValues from './processTemplateValues';

const AttributeLink = ({appConfig, definition, infoDefinition, values}) => {

    const classNames = mergeStyleSets({
        root: {
            paddingTop: 4,
            paddingBottom: 4,
            ...getStylesFromDefinition(appConfig, 'info.styles.attrContainer'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrContainer'),
            ...getStylesFromCssString(definition.containerStyles)
        }
    });

    const url = processTemplateValues(definition.urlTemplate, values);

    const target = definition.target || 'app_ext_link';

    return (
        <Stack className={classNames.root}>
            <Link href={url} target={target}>{definition.title}</Link>
        </Stack>
    );
}

export default AttributeLink;
